import { Transition } from "@headlessui/react";
import Heading from "components/Brand/Heading";
import Text from "components/Brand/Text";
import LoginUserButton from "components/LoginUserButton";
import EPButton from "components/UI/EPButton";
import Loader from "components/UI/Loader";
import useService from "hooks/useService";
import React, { useEffect, useRef, useState } from "react";
import { LeaderBoardService } from "service/LeaderBoardService";
import useAuthContext from "src/contexts/AuthContext";
import RankCard from "../RankCard";
import { FcGoogle } from "react-icons/fc";
import dynamic from "next/dynamic";
import CountryImage from "components/CountryImage";
import { useGameContext } from "src/contexts/GameContext";
import EPModal from "components/UI/EPModal";
import LeaderboardSVG from "public/svgs/leaderboard-active.svg";
import LeaderBoardInactive from "/public/svgs/leaderboard-inactive.svg";
import FadeTransition from "components/FadeTransition";
import clsx from "clsx";
import ViewGameLeaderBoardButton from "components/ViewGameLeaderBoardButton";

const SCORE_LIST_OPTIONS = {
  type: "score",
  region: "C",
  limit: 3,
  page: 1,
  period: "D",
  gameId: undefined,
  liveness: "realtime",
};

function GamePageLeaderBoard({ game }) {
  const { showGame } = useGameContext();
  const topScoreListOptionsRef = useRef(SCORE_LIST_OPTIONS);
  const [isOpen, setIsOpen] = useState(false);
  const userRankOptionsRef = useRef(SCORE_LIST_OPTIONS);
  const gameId = game?.ws?.gid;
  const { authUser, handleProviderLogin } = useAuthContext();
  const topScoreListApi = useService(LeaderBoardService.getTopLeaderBoard);
  const [combinedResults, setCombinedResults] = useState(null);
  async function getLeaderBoardData() {
    const top = await topScoreListApi.call(topScoreListOptionsRef.current);
    // const user = await usrRankApi.call(userRankOptionsRef.current);
    const topResults = top?.results || [];
    // const userRank = user?.data;

    // const isUserIntop = topResults.some(r => r.userId === authUser.userId);
    // setCombinedResults(isUserIntop ? topResults : [...topResults, userRank]);
    setCombinedResults([...topResults]);
  }
  function getDate(time) {
    if (!time) return;
    return new Date(time * 1000).toLocaleString();
  }

  useEffect(() => {
    if (!gameId || !authUser || showGame || !isOpen) return;
    topScoreListOptionsRef.current.gameId = gameId;
    userRankOptionsRef.current.gameId = gameId;
    // getRankList();
    getLeaderBoardData();
  }, [gameId, authUser, showGame, isOpen]);
  return (
    <>
      {/* trigger */}
      <FadeTransition>
        <button
          aria-label="view leaderboard"
          variant="icon"
          onClick={() => setIsOpen(true)}
          className={clsx(
            "flex aspect-square w-full items-center justify-center gap-2 rounded-full",
            "bg-transparent hover:bg-primary-content/50 active:bg-primary-content/70"
          )}
        >
          {" "}
          <LeaderBoardInactive
            alt="leaderboard"
            height={20}
            width={20}
            style={{
              fill: "currentColor",
            }}
          />
        </button>
      </FadeTransition>
      {/* dialog */}
      <EPModal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <div className="mx-auto flex h-full max-w-xl flex-col justify-between gap-2 rounded pt-0 xl:py-4">
          <div className="flex flex-col gap-2">
            <p className="primary-content text-center text-lg font-medium">
              Today's Top 3 Highscores
            </p>
            <Transition
              appear={true}
              show={true}
              enter="transition-opacity duration-75"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="mx-auto flex max-w-xl flex-col gap-2 rounded">
                <span className="flex items-center justify-center gap-2 text-xl font-bold text-primary-content">
                  {topScoreListApi?.data?.meta?.name}{" "}
                  <CountryImage
                    countryCode={topScoreListApi?.data?.meta?.countryCode}
                  />
                </span>
                {!!topScoreListApi?.data?.meta?.lastSyncAt && (
                  <span className="text-sm italic text-secondary-content">
                    Last updated at:{" "}
                    {getDate(topScoreListApi?.data?.meta?.lastSyncAt)}
                  </span>
                )}
              </div>
            </Transition>
            <div>
              {!topScoreListApi?.isLoaded || topScoreListApi?.isLoading ? (
                // || !usrRankApi?.isLoaded
                <Loader />
              ) : (
                <Transition
                  appear={true}
                  show={true}
                  enter="transition-opacity duration-75"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="transition-opacity duration-150"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="relative flex flex-col gap-2 overflow-y-auto">
                    {combinedResults?.length ? (
                      combinedResults?.map((player, index) => {
                        const user = authUser?.userId === player?.userId;
                        return (
                          <RankCard key={index} player={player} user={user} />
                        );
                      })
                    ) : topScoreListApi?.error ? (
                      <div>
                        <p className="mb-3">Failed to load the leaderboard</p>
                        <EPButton
                          variant="primary"
                          onClick={getLeaderBoardData}
                        >
                          Retry
                        </EPButton>
                      </div>
                    ) : (
                      <div className="flex flex-col gap-2 pb-4">
                        <Text justify={false} className="text-center">
                          Leaderboard is being updated. Please check back later.
                        </Text>
                      </div>
                    )}
                  </div>
                </Transition>
              )}
            </div>
          </div>
          <div className="mx-auto flex h-full flex-col gap-2">
            {/* <div className="mx-auto flex max-w-md flex-col gap-4 rounded pt-4">
              <ViewGameLeaderBoardButton game={game} />
            </div> */}
            {authUser && authUser?.anonymous && (
              <div className="mt-2 flex flex-col items-center justify-center gap-3">
                <span className="text-sm text-secondary-content">
                  Login & Play to compete with other players.
                </span>
                <EPButton
                  onClick={async () => {
                    handleProviderLogin();
                  }}
                  variant="secondary"
                  className="flex items-center justify-center gap-1 bg-neutral-50 text-neutral-800"
                >
                  {/* for now only google */}
                  <FcGoogle size={20} /> Login With Google
                </EPButton>
              </div>
            )}
          </div>
        </div>
      </EPModal>
    </>
  );
}

export default GamePageLeaderBoard;
